import { useMemo } from 'react'

import { F0Dialog, F0Form, f0FormField, useF0Form } from '@factorialco/f0-react'
import { z } from 'zod'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onReject: (reason: string) => void
  setShowRejectedModal: (value: boolean) => void
  rejecting: boolean
}

export const RejectModal = ({ onReject, setShowRejectedModal, rejecting }: Props) => {
  const { formRef, submit, hasErrors } = useF0Form()

  const handleClose = () => {
    setShowRejectedModal(false)
    track(trackingEvents.training.trainingRequest.rejectTrainingRequest.cancel)
  }

  const schema = useMemo(
    () =>
      z.object({
        reason: f0FormField(z.string().optional(), {
          label: i18n.t('trainings.training_requests.my_requests.detail.reject_modal.comments_label'),
          fieldType: 'textarea',
        }),
      }),
    []
  )

  return (
    <F0Dialog
      isOpen
      onClose={handleClose}
      title={i18n.t('trainings.training_requests.my_requests.detail.reject_modal.title')}
      primaryAction={{
        label: i18n.t('trainings.training_requests.my_requests.detail.reject_modal.reject'),
        onClick: submit,
        loading: rejecting,
        disabled: hasErrors || rejecting,
      }}
      secondaryAction={{
        label: i18n.t('trainings.training_requests.my_requests.detail.reject_modal.cancel'),
        onClick: handleClose,
      }}
    >
      <F0Form
        formRef={formRef}
        name="reject-training-request"
        schema={schema}
        defaultValues={{ reason: '' }}
        submitConfig={{ type: 'default', hideSubmitButton: true }}
        onSubmit={(data) => {
          onReject(data.reason ?? '')
          return { success: true }
        }}
      />
    </F0Dialog>
  )
}
